/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .fill {
    fill: ${theme.color.disableTxt};
  }
`

export default function WrenchIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18.193" height="18.193" viewBox="0 0 18.193 18.193" css={Color} className="wrench-svg">
      <g id="그룹_32433" data-name="그룹 32433" transform="translate(-150.903 -207.904)">
        <rect id="사각형_6694" data-name="사각형 6694" width="18" height="18" transform="translate(151 208)" fill="#fff" opacity="0"/>
        <g id="그룹_31220" data-name="그룹 31220" transform="translate(155.3 208.836)">
          <g id="그룹_31221" data-name="그룹 31221">
            <path id="패스_6867" data-name="패스 6867" d="M3.36,0a.7.7,0,0,1,.7.7V3.529H5.35V.71A.7.7,0,0,1,6.284.05,4.674,4.674,0,0,1,7.38,8.3v6.224a1.8,1.8,0,0,1-1.8,1.8H3.821a1.8,1.8,0,0,1-1.8-1.8V8.3A4.679,4.679,0,0,1,3.126.04.7.7,0,0,1,3.36,0ZM6.05,4.929H3.36a.7.7,0,0,1-.7-.7V1.875a3.277,3.277,0,0,0,.409,5.438.7.7,0,0,1,.351.607v6.608a.4.4,0,0,0,.4.4H5.579a.4.4,0,0,0,.4-.4V7.92a.7.7,0,0,1,.351-.607A3.274,3.274,0,0,0,6.75,1.887V4.229A.7.7,0,0,1,6.05,4.929Z" transform="translate(-4.397 5.715) rotate(-45)" fill="#eee"/>
          </g>
        </g>
      </g>
    </svg>
  )
}
